module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.02afb26f.ttf";